import { Card } from "@heroui/react"
import { LocalizedLink } from "~/components/common/localized-link"
import React from 'react'

import { useLocale } from 'use-intl'
import { usePublicCategories } from '~/features/categories/hooks/use-public-categories'

const featuredCategories = [
  { id: 237, name: 'Sushi', image: '/images/guides/categories/sushi/hero.png' },
  { id: 60, name: 'Ramen', image: '/images/guides/categories/ramen/hero.png' },
  { id: 3, name: 'Izakaya', image: '/images/guides/categories/izakaya/hero.png' },
  { id: 551, name: 'Tempura', image: '/images/guides/categories/tempura/hero.png' },
  { id: 82, name: 'Yakiniku', image: '/images/guides/categories/yakiniku/hero.png' },
  { id: 14, name: 'Tonkatsu', image: '/images/guides/categories/tonkatsu/hero.png' },
  { id: 101, name: 'Cafe', image: '/images/guides/categories/cafe/hero.png' },
  { id: 2001, name: 'Wagashi', image: '/images/guides/categories/wagashi/hero.png' },
]

import { getLocalizedCategoryName } from '~/features/categories/utils/localization'

export function FeaturedCategories({ t }: { t: any }) {
  const locale = useLocale()
  const { data: dbCategories } = usePublicCategories()
  return (
    <div className="w-full max-w-6xl mx-auto px-4">
      <div className="flex justify-between items-end mb-8">
        <h2 className="text-3xl font-bold">{t('guides.categoriesTitle')}</h2>
        <LocalizedLink to="/categories" className="text-primary hover:underline font-medium">
          {t('guides.viewAll')}
        </LocalizedLink>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {featuredCategories.map((cat) => {
          const dbCat = dbCategories?.find((c: any) => c.id === cat.id)
          const localizedName = getLocalizedCategoryName(dbCat, locale, cat.name)
          return (
            <LocalizedLink key={cat.id} to={`/categories/${cat.id}`} className="block group cursor-pointer">
              <Card className="border-none bg-transparent shadow-none">
                <div className="relative overflow-hidden rounded-xl aspect-[4/3]">
                  <img
                    src={cat.image}
                    alt={localizedName}
                    className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent z-10" />
                  <div className="absolute bottom-3 left-3 z-20">
                    <p className="text-white font-bold text-base md:text-lg drop-shadow-md">{localizedName}</p>
                  </div>
                </div>
              </Card>
            </LocalizedLink>
          )
        })}
      </div>
    </div>
  )
}
